import React, { useEffect } from "react";
import { PlaidLinkOptions } from "react-plaid-link";
import { NoAccountSVG } from "assets";
import LinkBank from "components/link-bank";

type NoAccountProps = {
  openPlaid: () => void;
  setPlaidConfig: React.Dispatch<
    React.SetStateAction<PlaidLinkOptions & { isSuccess?: boolean }>
  >;
  type: "program" | "group";
  groupId?: string;
};

function NoAccount({
  openPlaid,
  setPlaidConfig,
  type,
  groupId,
}: NoAccountProps) {
  useEffect(() => {
    const el = document.getElementById("img");
    el!.innerHTML = NoAccountSVG;
  }, []);

  return (
    <div className="flex justify-center">
      <div>
        <div id="img" className="h-96" />
        <p className="text-center">No linked Account</p>
        <LinkBank
          openPlaid={openPlaid}
          setPlaidConfig={setPlaidConfig}
          type={type}
          // labelText={"Link External Bank Account"}
          groupId={groupId}
        />
      </div>
    </div>
  );
}

export default NoAccount;
